import type { DashboardScoreModuleGrainEntity } from '@/core/infrastructure/schemas/dashboard/DashboardScoreModuleGrainSchema'
import { DashboardScoreModuleGrainSchema } from '@/core/infrastructure/schemas/dashboard/DashboardScoreModuleGrainSchema'
import { EvaluationRange } from '@/core/domain/resources/enums/EvaluationRange'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

export class DashboardScoreModuleGrain {
  readonly learningGrainId: number
  readonly learningGrainTitle: string
  readonly learningGrainOrder: number
  readonly postQuizVersionNumber: number | null
  readonly postQuizScoreScaled?: number | null
  readonly postQuizScoreScaledHistory: number[]
  readonly postQuizCountAttempt?: number | null
  readonly postQuizEvalRangeName: EvaluationRange.Values | null

  constructor(dashboardGrain: DashboardScoreModuleGrainEntity) {
    this.learningGrainId = dashboardGrain.learningGrainId
    this.learningGrainTitle = dashboardGrain.learningGrainTitle
    this.learningGrainOrder = dashboardGrain.learningGrainOrder
    this.postQuizVersionNumber = dashboardGrain.postQuizVersionNumber
    this.postQuizScoreScaled = dashboardGrain.postQuizScoreScaled
    this.postQuizScoreScaledHistory = dashboardGrain.postQuizScoreScaledHistory
    this.postQuizCountAttempt = dashboardGrain.postQuizCountAttempt
    this.postQuizEvalRangeName = dashboardGrain.postQuizEvalRangeName
  }

  /**
   * Crée une instance de DashboardScoreModuleGrain à partir de données brutes
   */
  public static create(data: unknown): DashboardScoreModuleGrain {
    return EntityValidator.validateAndCreate(
      DashboardScoreModuleGrainSchema,
      data,
      DashboardScoreModuleGrain,
      'DashboardScoreModuleGrain'
    )
  }
}
